import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { combineEpics } from 'web-app/util/redux-observable';
import { dispatchStatusMessageEvent } from '@famly/stat_ts-utils_global-messages';
import { getRestClientErrorMessage } from 'signin-app/api/clients/get-rest-client-error-message';
import { defaultErrorDuration } from 'web-app/react/global-event/helpers/constants';
import ChildApi from 'signin-app/api/child-api';
import * as Actions from './actions';
const goHomeWithChildren = action$ => action$.pipe(ofType(Actions.fetchGoHomeWithChildren.type), mergeMap(({ payload }) => ChildApi.goHomeWithChildren(payload.childId).pipe(map(groups => Actions.fetchGoHomeWithChildrenSuccess.action(groups)), catchError(e => {
    dispatchStatusMessageEvent({
        message: getRestClientErrorMessage(e),
        statusType: 'Error',
        sticky: false,
        e2eId: '',
        duration: defaultErrorDuration,
    });
    return of(Actions.fetchGoHomeWithChildrenFailed.action());
}))));
export default combineEpics(goHomeWithChildren);
